import React from 'react';
import { Image, View } from 'react-native';

import { Text } from 'react-native-web';
import { ScrollView } from 'react-native-gesture-handler';
import {
  getImageByKey,
  img_android_screen_list_search,
  img_android_screen_simple,
  img_android_screen_simple_keypad,
  img_imsg_scr,
  img_ios_screen_list_search,
  img_ios_screen_simple,
  img_ios_screen_simple_keyboard,
} from '../../../utils/ImagesManagementUtils';
import {
  Android, iMessage, iMsg_bank_logo, iOS,
} from '../../../utils/DictionaryManagementUtils';
import TopBarComponent from '../AuxiliaryComponent/TopBarComponent';
import TopVerticalLine from '../AuxiliaryComponent/TopVerticalLine';
import { getRef } from '../../../utils/Utils';
//= ========================================================================

const FullPageSimulator = ({
  children,
  globJSON, simPlatform, headlineText, keyboardType,
  hideIcons, hideArrow, TopTitle, WithGrayBackground, WithImageBackground, isMenu,
  hideTitle,
  hideCloseButton,
  hidePhoneHeadLine,
  hideGreyLine,
  floatingChildren,
  floatingChildrenTop,
  withExtraHeightForTitle,
  scrollDisabled,
  withOutPadding,
  withOutTopVerticalLine,
  withCheckIconOnTop,
  slideshowRefs = null,
  cleanBackgroundImage, BackgroundColor, withGrayCircle,
}) => {
  const marginTopWithTitle = simPlatform === Android ? 156 : 236;
  const marginTopWithOutTitle = simPlatform === Android ? 130 : 210;
  const heightForMobile = (platform) => {
    switch (platform) {
      default:
      case Android:
        return 295;
      case iOS:
        return 260;
      case iMessage:
        return 160;
    }
  };
  const imageHeight = simPlatform === Android ? 427 : 520;
  const InsideImessage = simPlatform === iMessage ? 310 : marginTopWithOutTitle;
  const { colors } = globJSON.configurations.theme;
  const MarginTopVerticalLineWithOutTitle = simPlatform === Android ? 128 : 208;
  const MarginTopVerticalLineWithTitle = simPlatform === Android ? 154 : 234;

  const myStyles = {
    insidePhoneScreen: {
      overflow: !cleanBackgroundImage && 'hidden',
      width: 240,
      height: heightForMobile(simPlatform),
      marginTop: TopTitle ? marginTopWithTitle : InsideImessage,
      position: 'absolute',
    },
    phoneImage: {
      width: 240,
      height: simPlatform === iMessage ? 470 : imageHeight,
      backgroundColor: BackgroundColor || colors.app_background_color,
    },
    title: {
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      marginBottom: 6,
      color: colors.primary_font_color,
    },
    greyPage: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
    TopVerticalLineStyle: {
      width: 240,
      marginTop: TopTitle ? MarginTopVerticalLineWithTitle : MarginTopVerticalLineWithOutTitle,
      position: 'absolute',
    },
    extraHeight: {
      marginTop: 25,
    },
    iMessageLogoStyle: {
      height: 22,
      width: 27.33,
      borderRadius: 9.6,
      backgroundColor: '#D8DAE0',
      borderColor: '#A8ADB0',
      borderWidth: 2,
      marginTop: 286.5,
      marginLeft: 80,
      alignSelf: 'center',
      position: 'absolute',
    },
  };

  const keyboardTypeArray = ['withoutKeyboard', 'numbersKeyboard', 'lettersKeyboard'];
  const defaultImageBackground = simPlatform === Android ? img_android_screen_simple : img_ios_screen_simple;
  const getBackgroundImage = () => {
    switch (keyboardType) {
      case keyboardTypeArray[0]:
        return (simPlatform === Android ? img_android_screen_simple : img_ios_screen_simple);
      case keyboardTypeArray[1]:
        return (simPlatform === Android ? img_android_screen_simple_keypad : img_ios_screen_simple_keyboard);
      case keyboardTypeArray[2]:
        return (simPlatform === Android ? img_android_screen_list_search : img_ios_screen_list_search);
      default:
        return (simPlatform === iMessage ? img_imsg_scr : defaultImageBackground);
    }
  };

  return (
    <View style={withExtraHeightForTitle && myStyles.extraHeight} ref={getRef(slideshowRefs)}>
      {TopTitle && <Text style={myStyles.title}>{TopTitle}</Text>}
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={WithImageBackground || getBackgroundImage()}
      />
      {simPlatform === iMessage
      && (
        <Image
          fadeDuration={0}
          style={myStyles.iMessageLogoStyle}
          source={getImageByKey(globJSON.configurations.services.menu.iMsg_bank_logo, iMsg_bank_logo)}
        />
      )}
      <View style={myStyles.insidePhoneScreen}>
        {!hidePhoneHeadLine
                && (
                <TopBarComponent
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  headlineText={headlineText}
                  hidePhoneHeadLine={hideIcons}
                  hideArrow={hideArrow}
                  hideTitle={hideTitle}
                  hideCloseButton={hideCloseButton}
                  isMenu={isMenu}
                  hideGreyLine={hideGreyLine}
                  withCheckIconOnTop={withCheckIconOnTop}
                  withOutPadding={withOutPadding}
                  withGrayCircle={withGrayCircle}
                />
                )}
        {floatingChildrenTop}
        <ScrollView
          vertical
          pagingEnabled={false}
          showsVerticalScrollIndicator={false}
          scrollEnabled={!scrollDisabled}
        >
          {children}
        </ScrollView>
        {floatingChildren}
      </View>
      {(simPlatform !== iMessage && !withOutTopVerticalLine) && (
        <View style={myStyles.TopVerticalLineStyle}>
          <TopVerticalLine
            globJSON={globJSON}
          />
        </View>
      )}
      {WithGrayBackground && (
        <View style={myStyles.greyPage} />
      )}
    </View>
  );
};
export default FullPageSimulator;
